/* eslint-disable react/prefer-stateless-function */
import debounce from 'lodash/debounce';
import { useDispatch } from 'react-redux';
import { CountBadge } from 'palette/Filters';
import { ListItem } from 'palette/List';
import { Toggle } from 'palette/Toggle';
import { toggleFilter } from '../actions/filtersActions';

import './BrandFilterItem.scss';

export function BrandFilterItem({ brand, isSelected }) {
    const dispatch = useDispatch();

    const { name, count } = brand;

    const filterClickHandler = debounce((event) => {
        event.preventDefault();
        dispatch(toggleFilter(brand));
    }, 250, {
        leading: true,
        trailing: false
    });

    if (count === 0) {
        return null;
    }

    return (
        <ListItem
            isActive={isSelected}
            rightContent={(<CountBadge count={count} />)}
            onClick={filterClickHandler}
        >
            <Toggle
                id={name}
                isChecked={isSelected}
                label={name}
                variant="checkbox"
            />
        </ListItem>
    );
}

export default BrandFilterItem;
